export function filterCardsByLabel<T>(cards: T[], query: string, getLabel: (c: T) => string): T[] {
    const trimmed = query.trim();
    if (!trimmed) return cards;
    const lower = trimmed.toLowerCase();
    return cards.filter((card) => {
        const label = getLabel(card);
        if (typeof label !== 'string' || !label) return false;
        return label.toLowerCase().includes(lower);
    });
}
